import React from "react";
import Header from "../components/header/header";

// Router Component
import MainRoute from "../router/main-route";

const MainLayout = ({history}) => {
    return (
        <>
            <div className="wraper">
                <Header history={history} />

                <MainRoute />
            </div>
        </>
    );
};

export default MainLayout;
